export const  linksFooter = () =>{

    if (document.querySelector("#pie-facebook")) {
        document.querySelector("#pie-facebook").addEventListener("click", function() { window.open("https://www.facebook.com/lanacion", "_blank") });
    }

    if(document.querySelector("#pie-twitter"))
        document.querySelector("#pie-twitter").addEventListener("click", function() { window.open("https://twitter.com/LANACION", "_blank") });
    
    if(document.querySelector("#pie-instagram"))
        document.querySelector("#pie-instagram").addEventListener("click", function() { window.open("https://www.instagram.com/lanacioncom/", "_blank") });
    
    if(document.querySelector("#pie-rss"))
        document.querySelector("#pie-rss").addEventListener("click", function() { window.open("http://servicios.lanacion.com.ar/herramientas/rss/ayuda", "_blank") });
    
    if(document.querySelector("#pie-apple"))
        document.querySelector("#pie-apple").addEventListener("click", function() { window.open("https://www.google.com.ar/url?sa=t&rct=j&q=&esrc=s&source=web&cd=1&cad=rja&uact=8&ved=0ahUKEwjsqvOLkr7XAhUDjpAKHZyiBigQFgglMAA&url=https%3A%2F%2Fitunes.apple.com%2Far%2Fapp%2Fla-nacion%2Fid410689702%3Fmt%3D8&usg=AOvVaw3LqfU_ag8u27BMNAtmRxqN", "_blank") });
    
    if(document.querySelector("#pie-android"))
        document.querySelector("#pie-android").addEventListener("click", function() { window.open("https://play.google.com/store/apps/details?id=app.lanacion.activity&hl=es_419", "_blank") });

    
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/footer.js